import styled from 'styled-components';

export default styled.div`
  padding: 34px 42px 40px;
  color: #26384f;
  font-size: 15px;
  line-height: 1.65;

  h1 {
    margin: 0 42px 22px 0;
    color: var(--primary-color);
    font-family: 'Montserrat', sans-serif;
    font-size: 26px;
    line-height: 1.25;
    font-weight: 800;
    border-bottom: 1px solid #e4e7f0;
    padding-bottom: 16px;
    @media (max-width: 720px) {
      font-size: 20px;
      margin-right: 28px;
    }
  }

  p{
    margin: 0 0 16px;
    @media (max-width: 720px) {
      font-size: 13px;
    }
  }

  strong {
    color: var(--primary-color);
    font-weight: 800;
  }

  ul,
  ol {
    margin: 0 0 18px 22px;
    padding: 0;
  }

  li {
    margin-bottom: 8px;
  }

  img {
    display: block;
    margin: 24px auto 8px;
    height: auto;
    max-width: min(620px, 100%);
    border-radius: 4px;
    border: 1px solid #e4e7f0;
    @media (max-width: 720px) {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  label {
    font-style: italic;
    font-size: 12px;
    display: block;
    margin: 8px auto 28px auto;
    width: 100%;
    text-align: center;
    color: #667a99;
  }

  @media (max-width: 720px) {
    padding: 26px 22px 30px;
  }
`;
